"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredDriverLicences = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importStar(require("styled-components"));
const A_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/A.svg"));
const A1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/A1.svg"));
const A2_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/A2.svg"));
const AM_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/AM.svg"));
const B_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/B.svg"));
const B1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/B1.svg"));
const BE_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/BE.svg"));
const C_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/C.svg"));
const C1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/C1.svg"));
const C1E_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/C1E.svg"));
const CE_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/CE.svg"));
const D_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/D.svg"));
const D1_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/D1.svg"));
const D1E_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/D1E.svg"));
const DE_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/DE.svg"));
const T_svg_1 = __importDefault(require("@public/media/illustrations/driverLicences/T.svg"));
const RowDiv = styled_components_1.default.div `
	display: flex;
	width: 100%;
	max-width: 300px;
	justify-content: space-between;
	margin-bottom: 0.5rem;
`;
const TitleWrapper = styled_components_1.default.span `
	color: ${({ theme }) => theme.color.gray6};
	margin-bottom: 0.5rem;
	width: 80px;
	${({ alignEnd }) => alignEnd &&
    (0, styled_components_1.css) `
			text-align: end;
		`}
`;
const DriverLicenceWithIcon = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	width: 30%;
	justify-content: space-between;
	align-items: center;
`;
const SvgWrapper = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	margin-left: 0.25rem;

	svg {
		width: 3rem;
		height: 1.5rem;
	}
`;
const driverLicenceIcons = {
    AM: AM_svg_1.default,
    A1: A1_svg_1.default,
    A2: A2_svg_1.default,
    A: A_svg_1.default,
    B1: B1_svg_1.default,
    B: B_svg_1.default,
    BE: BE_svg_1.default,
    C1: C1_svg_1.default,
    C1E: C1E_svg_1.default,
    C: C_svg_1.default,
    CE: CE_svg_1.default,
    D1: D1_svg_1.default,
    D1E: D1E_svg_1.default,
    D: D_svg_1.default,
    DE: DE_svg_1.default,
    T: T_svg_1.default,
};
const RequiredDriverLicences = ({ driverLicences }) => {
    const showMileageTitle = driverLicences === null || driverLicences === void 0 ? void 0 : driverLicences.some(licence => licence.mileage);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(RowDiv, { children: [(0, jsx_runtime_1.jsx)(TitleWrapper, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.licence_type" }) }), Boolean(showMileageTitle) && ((0, jsx_runtime_1.jsx)(TitleWrapper, { alignEnd: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.mileage" }) }))] }), (driverLicences || []).map((licence, i) => {
                const { mileage } = licence;
                const driverLicence = licence.driverLicence || licence.driving_licence_type;
                const Icon = driverLicenceIcons[driverLicence];
                return ((0, jsx_runtime_1.jsxs)(RowDiv, { children: [(0, jsx_runtime_1.jsxs)(DriverLicenceWithIcon, { children: [driverLicence, (0, jsx_runtime_1.jsx)(SvgWrapper, { children: (0, jsx_runtime_1.jsx)(Icon, {}) })] }), Boolean(mileage) && (0, jsx_runtime_1.jsx)("div", { children: mileage })] }, `${i}-${driverLicence}`));
            })] }));
};
exports.RequiredDriverLicences = RequiredDriverLicences;
